import { render, staticRenderFns } from "./EssentialsBannedMaterials.vue?vue&type=template&id=b5961c10&scoped=true&"
import script from "./EssentialsBannedMaterials.vue?vue&type=script&lang=js&"
export * from "./EssentialsBannedMaterials.vue?vue&type=script&lang=js&"
import style0 from "./EssentialsBannedMaterials.vue?vue&type=style&index=0&id=b5961c10&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5961c10",
  null
  
)

export default component.exports